module.exports = __webpack_public_path__ + "img/blockdit.d9c701c0.svg";